import { WA_MSG, WHATSAPP_DISPLAY, WHATSAPP_PHONE_LABEL, whatsappUrl } from '../lib/whatsapp.js';

const plans = [
  {
    name: 'Starter',
    price: '97',
    note: 'Uma loja em ritmo de crescimento.',
    features: ['Até 3 unidades', 'WhatsApp automático', 'App do barbeiro', 'Relatórios essenciais'],
    cta: 'Falar no WhatsApp',
    href: whatsappUrl(WA_MSG.starter),
    featured: true,
  },
  {
    name: 'Pro',
    price: '247',
    note: 'Redes e franquias com mais controle.',
    features: ['Até 10 unidades', 'API e integrações', 'Relatórios avançados', 'Suporte prioritário'],
    cta: 'Falar no WhatsApp',
    href: whatsappUrl(WA_MSG.pro),
    featured: false,
  },
  {
    name: 'Free',
    price: '0',
    note: 'Para conhecer o fluxo sem compromisso.',
    features: ['1 unidade', '3 usuários', 'Agenda e clientes', 'WhatsApp manual'],
    cta: 'Falar no WhatsApp',
    href: whatsappUrl(WA_MSG.free),
    featured: false,
  },
];

export default function Pricing() {
  return (
    <section id="planos" className="bg-ink py-24 lg:py-32">
      <div className="mx-auto max-w-content px-6 lg:px-8">
        <div className="max-w-lg">
          <p className="text-sm font-medium tracking-wide text-copper">Planos</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-bone sm:text-4xl text-balance">
            Preço claro. Sem surpresa no fechamento.
          </h2>
          <p className="mt-4 text-sm text-mist">
            Contratação pelo WhatsApp com {WHATSAPP_DISPLAY} · {WHATSAPP_PHONE_LABEL}
          </p>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-3">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={[
                'flex flex-col border p-7 transition-colors',
                plan.featured
                  ? 'border-copper/50 bg-ink-soft'
                  : 'border-white/10 bg-transparent hover:border-white/20',
              ].join(' ')}
            >
              <div className="flex items-baseline justify-between gap-3">
                <h3 className="font-display text-lg font-semibold text-bone">{plan.name}</h3>
                {plan.featured && (
                  <span className="text-[11px] font-medium uppercase tracking-wider text-copper">
                    recomendado
                  </span>
                )}
              </div>
              <p className="mt-2 text-sm text-mist">{plan.note}</p>
              <p className="mt-6 font-display text-4xl font-bold tabular-nums tracking-tight text-bone">
                R$ {plan.price}
                <span className="ml-1 text-base font-medium text-mist">/mês</span>
              </p>
              <ul className="mt-8 flex-1 space-y-3">
                {plan.features.map((f) => (
                  <li key={f} className="text-sm text-bone/85">
                    <span className="mr-2 text-copper">—</span>
                    {f}
                  </li>
                ))}
              </ul>
              <a
                href={plan.href}
                target="_blank"
                rel="noopener noreferrer"
                className={[
                  'mt-8 block rounded-md px-4 py-2.5 text-center text-sm font-semibold transition-colors active:scale-[0.98]',
                  plan.featured
                    ? 'bg-copper text-ink hover:bg-copper-soft'
                    : 'border border-white/15 text-bone hover:border-copper hover:text-copper',
                ].join(' ')}
              >
                {plan.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
